var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6V6.75H6.01287C5.05332 6.75 4.24862 7.47444 4.14817 8.42872L2.88502 20.4287C2.76848 21.5358 3.63652 22.5 4.74971 22.5H20.2504C21.3636 22.5 22.2317 21.5358 22.1151 20.4287L20.852 8.42872C20.7515 7.47444 19.9468 6.75 18.9873 6.75H17V6C17 3.51472 14.9853 1.5 12.5 1.5C10.0147 1.5 8 3.51472 8 6ZM12.5 3C10.8431 3 9.5 4.34315 9.5 6V6.75H15.5V6C15.5 4.34315 14.1569 3 12.5 3ZM9.5 11.25C9.5 12.9069 10.8431 14.25 12.5 14.25C14.1569 14.25 15.5 12.9069 15.5 11.25V10.5C15.5 10.0858 15.8358 9.75 16.25 9.75C16.6642 9.75 17 10.0858 17 10.5V11.25C17 13.7353 14.9853 15.75 12.5 15.75C10.0147 15.75 8 13.7353 8 11.25V10.5C8 10.0858 8.33579 9.75 8.75 9.75C9.16421 9.75 9.5 10.0858 9.5 10.5V11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.cb70cfa365ab5ad1f0beaecd7c88ea8a.svg";
export { ForwardRef as ReactComponent };